import React, { useState, useRef, useEffect } from 'react'
import { connect } from 'react-redux'
import {
    Container,
    Spinner
} from 'react-bootstrap'
import { Link } from 'react-router-dom'
import FeatherIcon from 'feather-icons-react';
import {
    useFormik
} from 'formik'
import VendorsFormContentView from './Includes/VendorsFormContentView'
import { setGlobalLoading } from 'redux/actions/actionCommon'
import { formValidationSchema, initialCreateFormValues } from './Helper';
import { ERROR_WHILE_UPDATING_VENDOR } from 'utlis/AppMessages/AppMessages';
import { toast } from 'react-toastify';
import {
    VENDOR_UPDATED_SUCCESSFULLY,
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE_GETTING_VENDOR_DETAILS,
}
    from 'utlis/AppMessages/AppMessages';
import { cancelGetVendorDetailsApi, editVendor, getVendorDetails } from 'utlis/Apis/Vendor_API';
import { getCustomerCountries } from 'utlis/Apis/Customers_API';
function EditVendor(props) {
    const submitButtonRef = useRef(null)

    const [editButtonDisable, setEditButtonDisable] = useState(false)
    const [editButtonLoading, setEditButtonLoading] = useState(false)
    // const [customergroupId, setVendorId] = useState([])
    const [vendor, setVendor] = useState({})
    const [countries, setCountries] = useState([])

    const setFormData = (vendorData) => {
        setVendor(vendorData)
    }
    useEffect(() => {
        getCountries_()
        const customerGroupId = props.match.params.id ?? ""
        getVendorDetails(props.currentUser.userToken, customerGroupId).then(res => {
            const vendorData = res.data
            if (vendorData.success) {
                setFormData(vendorData.data)
            }
            if (vendorData.error) {
                console.log(ERROR_WHILE_GETTING_VENDOR_DETAILS, res)
                toast.dismiss();
                toast.error(ERROR_WHILE_GETTING_VENDOR_DETAILS, {
                    autoClose: 3000,
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getVendorDetails `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            })
        })

        return () => {
            cancelGetVendorDetailsApi()
        }
        // }
    }, [props.match.params.id, props.location.state, props.currentUser.userToken])



    const onEditFormSubmit = values => {
        if (values) {
            setGlobalLoading(true)
            setGlobalLoading(true)
            setEditButtonDisable(true)
            setEditButtonLoading(true)
            editVendor(props.currentUser.userToken, values).then(res => {
                setGlobalLoading(false)
                setGlobalLoading(false)
                setEditButtonDisable(false)
                setEditButtonLoading(false)
                const addingVendor = res.data
                if (addingVendor.success) {
                    onSuccess(addingVendor.data)
                }
                if (addingVendor.error) {
                    onError(res)
                }
            }).catch(err => {
                setEditButtonLoading(false)
                console.log(`${ERROR_WHILE__NAME} getVendorDetails `, err.message)
                onCatch()
            })
        }
    }
    const onError = (res) => {
        setEditButtonLoading(false)
        console.log(ERROR_WHILE_UPDATING_VENDOR, res)
        toast.dismiss();
        toast.error(ERROR_WHILE_UPDATING_VENDOR, {
            autoClose: 3000,
        })
    }
    const onCatch = () => {
        toast.dismiss();
        toast.error(UNKNOWN_ERROR_OCCURED, {
            autoClose: 2500,
            onClose: () => {
                setEditButtonLoading(false)
                setGlobalLoading(false)

            }
        })

    }
    const onSuccess = () => {
        setEditButtonLoading(true)
        window.scrollTo(0, 0)
        toast.dismiss();
        setEditButtonLoading(false)
        toast.success(VENDOR_UPDATED_SUCCESSFULLY, {
            autoClose: 2000,
            onClose: () => { }
        })
    }

    const getCountries_ = () => {
        getCustomerCountries().then(res => {
            const countriesData = res.data
            if (countriesData.success) {
                setCountries(countriesData.data)
            }
            if (countriesData.error) {
                console.log('Error occured while loading countries groups!', res)
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCountries `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            })
        })
    }

    const formik = useFormik({
        initialValues: initialCreateFormValues(vendor),
        validationSchema: formValidationSchema,
        onSubmit: onEditFormSubmit,
        enableReinitialize: true
    })



    const handleFormSubmission = (ev) => {
        ev.preventDefault()

        submitButtonRef.current.click()
    }

    return (
        <section id="app-vendors__edit-details" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-vendors__edit-details">
                    <div className="back-button-wrapper mb-2">
                        <Link to="/catalog/vendors" className="text-decoration-none st-text-primary d-inline-flex align-items-center cursor-pointer st-fs-15">
                            <FeatherIcon
                                icon="arrow-left"
                                size="14"
                                className="icon me-1" />
                            <span>Back to vendors</span>
                        </Link>
                    </div>

                    <div className="app-header-wrapper mb-3">
                        <p className="app-heading text-capitalize">Edit Vendors</p>
                        <p className="app-desc">
                            Edit a vendor.
                        </p>
                    </div>

                    <form
                        onSubmit={formik.handleSubmit}
                        noValidate
                        autoComplete="off">
                        <div className="app-content-container">

                            <VendorsFormContentView
                                formik={formik}
                                countries={countries}
                            />
                            <div className={`app-card page-bottom-action-btns ${props.sideBarVisibility ? "" : "sidebar-expanded"}`}>
                                <div className="app-card-content bg-white border-top st-border-light d-flex align-items-center justify-content-end">
                                    <Link to="/catalog/vendors" className="st-btn st-btn-link no-min-width d-flex align-items-center justify-content-center me-1">
                                        Cancel
                                    </Link>
                                    <button
                                        type="submit"
                                        className={`st-btn st-btn-primary d-flex align-items-center justify-content-center ${(editButtonDisable || Object.keys(formik.errors).length) ? "disabled" : ""}`}
                                        disabled={editButtonDisable || Object.keys(formik.errors).length}
                                        onClick={handleFormSubmission}>
                                        {
                                            editButtonLoading ? (
                                                <Spinner animation="border" size="sm" />
                                            ) : (
                                                <span>Update Vendor</span>
                                            )
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>

                        <button type="submit" ref={submitButtonRef} className="d-none">submit</button>
                    </form>

                </div>
            </Container>
        </section>
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(EditVendor)